import styled, {keyframes} from 'styled-components';

export const PricingContainer = styled.div`
  .select-plan{
    display:flex;
    align-items:center;
    column-gap:10px;
  }
  .plan-label{
    font-size:0.7rem
  }
  .plan-list{
    position:relative;
    cursor: pointer; 
    display:flex;
    gap: 5px;
    align-items:center;
    justify-content: flex-start;
  }
  .dropDown-list{
    padding:5px;
    position: absolute;
    background: #000000;
    color: #FFFFFF;
    width: 165px;
    border-radius:4px;
    cursor: pointer;
    visibility: hidden;
    opacity: 0;
    box-shadow: 0px 3px 5px -1px #ccc;
    bottom:${props => props.pos === 'top' ? '100%' : 'auto'};
    top: ${props => props.pos === 'bottom' ? '100%' : 'auto'};
    text-align: left;
    .plans-list{
      border-bottom:1px solid #091E420F;
      .plan-name {
        padding: 5px 10px 0 10px;
        color: white;
        font-weight: 600;
      }
      .plans-category {
        .plans-category-list {
          padding: 5px 0 5px 20px;
          font-size: 14px;
        }
        
        .plans-category-list:hover {
          background: white;
          color: black;
        }
      }
      
    }
    .plans-list:last-child{
      border-bottom:none; 
    }

  }
  .show-list{
    visibility: visible; 
    opacity: 1;
    z-index: 10;
  }
  .selected-plan{
    color: rgba(0, 0, 0, 0.85);
    font-size:1.4rem;
    font-weight: 600;
  }
  .month-label{
    font-size:0.7rem;
    line-height:14px;
    text-align:left;
  }
`;